import { detectIsTouch } from "../analytics/perf-monitor.js";

/** Fade duration (ms) — keep in sync with `fall-move-hint-out` in style.css. */
export const FALL_MOVE_HINT_FADE_MS = 280;

const exitState = new WeakMap();

/** Control hints are desktop-only; touch devices never show them. */
export function areControlHintsEnabled() {
  return detectIsTouch() !== 1;
}

/**
 * Play-column toast fade helper (`#fallMoveHint`, `#shakeDropHint`, `#playerPauseHint`).
 * Control pictograms stay desktop-only; pass `{ ignoreTouchGate: true }` for status
 * toasts that must also show on phones (e.g. PAUSED).
 *
 * @param {HTMLElement | null | undefined} mount
 * @param {boolean} visible
 * @param {{ ignoreTouchGate?: boolean }} [opts]
 */
export function setFallMoveHintVisible(mount, visible, opts) {
  if (!mount) return;
  var ignoreTouchGate = !!(opts && opts.ignoreTouchGate);
  if (!ignoreTouchGate && !areControlHintsEnabled()) {
    if (visible) return;
  }

  cancelFallMoveHintExit(mount);

  if (visible) {
    mount.classList.remove("hidden", "fall-move-hint--out");
    mount.setAttribute("aria-hidden", "false");
    return;
  }

  if (mount.classList.contains("hidden") || mount.classList.contains("fall-move-hint--out")) {
    return;
  }

  mount.setAttribute("aria-hidden", "true");

  var done = false;
  var finish = function () {
    if (done) return;
    done = true;
    cancelFallMoveHintExit(mount);
    mount.classList.remove("fall-move-hint--out");
    mount.classList.add("hidden");
  };

  var onAnimationEnd = function (event) {
    if (event.target !== mount || event.animationName !== "fall-move-hint-out") return;
    finish();
  };

  var fallbackId = setTimeout(finish, FALL_MOVE_HINT_FADE_MS + 32);
  if (typeof mount.addEventListener === "function") {
    mount.addEventListener("animationend", onAnimationEnd);
  }
  exitState.set(mount, { onAnimationEnd: onAnimationEnd, fallbackId: fallbackId });
  mount.classList.add("fall-move-hint--out");
}

function cancelFallMoveHintExit(mount) {
  var pending = exitState.get(mount);
  if (!pending) return;
  clearTimeout(pending.fallbackId);
  if (typeof mount.removeEventListener === "function") {
    mount.removeEventListener("animationend", pending.onAnimationEnd);
  }
  exitState.delete(mount);
  mount.classList.remove("fall-move-hint--out");
}